"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultCollissionResolver = function (elementName) { return "_" + elementName; };
//# sourceMappingURL=default-collision-resolver.js.map


// WEBPACK FOOTER //
// ./node_modules/kentico-cloud-delivery/_commonjs/config/default-collision-resolver.js